var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconInspection = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M6 4h12v16H6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 2h12a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2zm0 2v16h12V4H6z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.667a3.335 3.335 0 0 0 0 6.666 3.335 3.335 0 0 0 0-6.666z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.426 12.181a.222.222 0 0 1 .003-.311.219.219 0 0 1 .31-.003l.791.79a.568.568 0 0 1 .038-.04l1.493-1.494a.524.524 0 0 1 .389-.151l.075.008.009.075a.526.526 0 0 1-.159.383l-1.493 1.493a.515.515 0 0 1-.14.099.246.246 0 0 1-.02.05l-.036.047a.221.221 0 0 1-.231.054.384.384 0 0 0 .074.103l-1.103-1.103z",
    fill: "#FFF"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconInspection);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-inspection.412ddc6daa83477e1ff34bd0e4534bad.svg";